import { useContext, useEffect, useState } from "react";
import ModalAutoTSuccess from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoTSuccess/ModalAutoTSucces";
import { wsGetDemora } from "_+_Portal/_-_Autocheckin/context/action/demora";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { wsPostAsignarPresente } from "_+_Portal/_-_Autocheckin/context/action/presente";
import { setTurnosRecepcionados } from "_+_Portal/_-_Autocheckin/context/action/turnosRecepcionados";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { setIdTipoPuntoControl } from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { getLocalStorage } from "global/utils/safeJsonParse";
import { marcarPresenteEnProceso } from "_+_Portal/_-_Autocheckin/utils/presenteTracker";

const TurnoProximo = ({ setTurnoActual, turnoActual, setLoading }) => {
  // -------------------------  context ----------------------------
  const {
    turnosSeleccionadosState,
    pasoDispatch,
    turnosRecepcionadosDispatch,
    presenteDispatch,
    ubicacionState,
    demoraDispatch,
    textosAutoCheckinState,
    puntoControlDispatch,
    pasoState,
  } = useContext(AutocheckContext);

  // -------------------------  context ----------------------------

  // -------------------------  constantes ----------------------------

  const listTurnosSeleccionado =
    turnosSeleccionadosState.turnosSeleccionados?.data ?? [];
  const turno = listTurnosSeleccionado[turnoActual];
  const actual = turnoActual + 1;
  const turnosLenAll = listTurnosSeleccionado.length;
  const config = getLocalStorage("config", {});
  let sectorTurno = config?.sectorTurno;
  let opcFilaVirtual = config?.opcFilaVirtual;
  let idTerminal = getLocalStorage("idTerminal");
  const [showComponent, setShowComponent] = useState(false);
  // -------------------------  constantes ----------------------------

  const callBack = (origen) => {
    if (origen === "proximoTurno") {
      if (pasoState.circuito === "labo") {
        setPaso("ResumenLabo")(pasoDispatch);
      } else {
        setPaso("Resumen")(pasoDispatch);
      }
    } else {
      if (!ubicacionState.ubicacion.data) {
        if (idTerminal) {
          setPaso("TurnosRecepcionados")(pasoDispatch);
        } else {
          setPaso("TurnosRecepcionadosQR")(pasoDispatch);
        }
      } else {
        if (opcFilaVirtual) {
          if (ubicacionState.ubicacion.data) {
            wsGetDemora(
              turno?.idEspecialidad,
              turno?.idMedico,
              turno?.idturno,
              false,
              (isCorrect, demora) => irAFilaVirtual(isCorrect, demora),
            )(demoraDispatch);
          } else {
            setPaso("FilaVirtualCasa")(pasoDispatch);
          }
        } else {
          if (idTerminal) {
            setPaso("TurnosRecepcionados")(pasoDispatch);
          } else {
            setPaso("TurnosRecepcionadosQR")(pasoDispatch);
          }
        }
      }
    }
  };

  const irAFilaVirtual = (isCorrect, demora) => {
    // let toleranciaDemoraMinutos =
    //   textosAutoCheckinState.textosAutoCheckin?.data?.colaVirtualPregunta
    //     ?.orden;
    if (isCorrect) {
      // if (demora.demora > toleranciaDemoraMinutos) {
      //   setPaso("FilaVirtual")(pasoDispatch);
      // } else {
      setPaso("TurnosRecepcionados")(pasoDispatch);
      // }
    }
  };

  const proximoTurno = () => {
    setTurnosRecepcionados(turno)(turnosRecepcionadosDispatch);
    setLoading("Cargando...");
    setPaso("Loading")(pasoDispatch);
    callBack("proximoTurno");
    setTurnoActual(turnoActual + 1);
  };

  const finzalizarRecepcion = () => {
    setTurnosRecepcionados(turno)(turnosRecepcionadosDispatch);
    setLoading("Cargando...");
    setPaso("Loading")(pasoDispatch);
    callBack("finzalizarRecepcion");
    setTurnoActual(0);
  };

  useEffect(() => {
    const idTurno = turno?.idturno;
    if (!marcarPresenteEnProceso(idTurno)) {
      return;
    }

    wsPostAsignarPresente(idTurno, sectorTurno, (isCorrect, data) => {
      if (!isCorrect) {
        console.error("[CheckinQR] TurnoProximo: asignarPresente rechazado", {
          idTurno: turno?.idturno,
          sectorTurno,
        });
        setLoading(true);
        const idTipoPuntoControl = 11;
        setIdTipoPuntoControl(
          idTipoPuntoControl,
          data?.detail ? data?.detail : "",
        )(puntoControlDispatch);
        setPaso("PuntoControl")(pasoDispatch);
      } else if (actual < turnosLenAll) {
        setShowComponent(true);
      } else {
        finzalizarRecepcion();
      }
    })(presenteDispatch);
  }, []);

  return (
    <>
      {showComponent ? (
        <ModalAutoTSuccess
          descripcion={`
        El turno ${actual} de ${turnosLenAll} ha sido recepcionado correctamente <br/>
        `}
          textBtn={
            actual === turnosLenAll
              ? `Finalizar la recepción`
              : `Continuar Recepción`
          }
          onClick={actual === turnosLenAll ? finzalizarRecepcion : proximoTurno}
        />
      ) : (
        <Loading
          dataLoading={true}
          descripcion="Cargando..."
          color={"c-white"}
        />
      )}
    </>
  );
};

export default TurnoProximo;
